import { Divider, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import PageTitleSection from "../../components/reusable/PageTitleSection/PageTitleSection";
import "./Experiments.css";
import articles from "../../utils/resources/experiments.json";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/knowledge.json";
import PublicationListItem from "../../components/reusable/PublicationListItem/PublicationListItem";

export default function Experiments() {
  const { language } = useCurrentLanguage();
  const [currentListOfResources] = useState(
    articles.sort((a, b) => b.date - a.date)
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const onPaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    window.scrollTo({ top: 100, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [currentListOfResources]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="knowledge-page-container">
      <div className="knowledge-page-title">
        <PageTitleSection
          title={TEXT["title"][language]}
          descriptionParagraphs={TEXT["description"][language]}
          image={"knowledge.png"}
        />
      </div>
      <div className="rp-pagination">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          responsive={true}
          total={currentListOfResources.length}
          onChange={onPaginationChange}
          hideOnSinglePage={true}
        />
      </div>
      <Divider />
      <div className="knowledge-page-content">
        {currentListOfResources.length > 0 ? (
          currentListOfResources.map((article, key) => (
            <PublicationListItem
              key={key}
              title={article.title ?? ""}
              author={article.author ?? ""}
              country={article.country ?? ""}
              programArea={article.region ?? ""}
              description={article.description ?? ""}
              topics={article.topics ?? ""}
              code={article.code ?? ""}
              status={article.status ?? ""}
              language={language}
              imageFileName={article.imageFileName ?? null}
            />
          ))
        ) : (
          <div className="rp-no-articles">No Articles Found</div>
        )}
      </div>
      <div className="rp-pagination">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          responsive={true}
          total={currentListOfResources.length}
          onChange={onPaginationChange}
          hideOnSinglePage={true}
        />
      </div>
    </div>
  );
}
